import { connect } from 'react-redux';
import App from './App';

import { restoreStateAndSelectionHandler } from '../../actions/booking';
import { restoreApp } from '../../actions/session';
import { loadConfiguration } from '../../actions/app';

const mapStateToProps = state => ({
  organizationName: state.organization.name,
  organizationLogoUrl: state.organization.logoUrl,
  userIdentified: state.session.userIdentified,
  currentlyRegistering: state.session.currentlyRegistering,
  fetchingReservation: state.cancelling.fetchingReservation,
  cancellingReservation: state.cancelling.cancellingReservation,
  currentlyIdentifying: state.session.currentlyIdentifying,
  rootLoading: state.booking.rootLoading,
  pathLoading: state.booking.pathLoading,
  requestingTimeSlots: state.booking.requestingTimeSlots,
  storingReservation: state.booking.storingReservation,
  sessionTimeout: state.session.sessionTimeout,
  loadingLocalizations: state.app.loadingLocalizations,
  loadingConfiguration: state.app.loadingConfiguration,
  googleAnalyticsTrackingId: state.organization.googleAnalyticsTrackingId,
  googleTagManagerId: state.organization.googleTagManagerId,
  historyInitialLoading: state.history.historyInitialLoading,
  historyLoading: state.history.historyLoading,
  loadingStaticData: state.app.loadingStaticData,
  bankRedirectingInProcess: state.session.bankRedirectingInProcess
});

const mapDispatchToProps = dispatch => ({
  loadConfiguration: dispatch(loadConfiguration),
  resetAppState: dispatch(restoreApp),
  loadInitialState: dispatch(restoreStateAndSelectionHandler)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js